import React, { createContext, useState } from "react";

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
    const [PCID] = useState(localStorage.getItem('pc_id'));
    const [categories, setStateCategories] = useState(() => {
        const storedCategories = localStorage.getItem('categories');
        return storedCategories && storedCategories !== 'undefined' ? JSON.parse(storedCategories) : [];
    });

    const [treeCategories, setStateTreeCategories] = useState([]);
    const setCategories = async (data) => {
        localStorage.setItem('categories', JSON.stringify(data));
        setStateCategories(data);
        var treecats = "";
        treecats = await CreateTree(data.filter((item) => item.TotalPrices > 0), PCID);
        treecats = treecats.filter(item => !(!item.children || item.children.length === 0));

        setStateTreeCategories(treecats);
    }

    const CreateTree = async (data, PC_ID) => {
        const nodes = {};
        const rootNodes = [];

        // Create all nodes without assigning children
        await data.forEach(item => {
            const node = new Node(item.STR_ID, item.STR_NODE_NAME, item.TotalPrices);
            nodes[item.STR_ID] = node;
        });

        // Assign children to their parents
        data.forEach(item => {
            const node = nodes[item.STR_ID];
            if (item.STR_ID_PARENT === null) {
                rootNodes.push(node);
            } else {
                const parentNode = nodes[item.STR_ID_PARENT];
                try {
                    if (node.TotalPrices > 0) {
                        parentNode.addChild(node);
                    }
                    // if(PC_ID && PC_ID !==0)
                    // {
                    //     if (node.TotalPrices > 0) {
                    //         parentNode.addChild(node);
                    //     }
                    // }else{
                    //     parentNode.addChild(node);
                    // }
                } catch (err) {

                }

            }
        });

        // Convert the list of root nodes to a dictionary representation
        var tree = rootNodes.map(node => node.toDict());

        return tree;
    }


    class Node {
        constructor(STR_ID, STR_NODE_NAME, TotalPrices) {
            this.STR_ID = STR_ID;
            this.STR_NODE_NAME = STR_NODE_NAME;
            this.TotalPrices = TotalPrices;
            this.children = [];
        }

        addChild(childNode) {
            this.children.push(childNode);
        }

        toDict() {
            return {
                STR_ID: this.STR_ID,
                STR_NODE_NAME: this.STR_NODE_NAME,
                TotalPrices: this.TotalPrices,
                children: this.children.map(child => child.toDict())
            };
        }
    }

    var vals = {
        gdcURL: 'https://dcapi.carz7.com',
        PCID,
        setCategories,
        categories,
        treeCategories,
        apiB2BURL: 'https://b2bapi.ghayar.com',
    };
    return (
        <ConfigContext.Provider value={vals}>{children}</ConfigContext.Provider>
    );
};
